import Button from 'components/_parts/atoms/button';
import Input from 'components/_parts/atoms/input';
import Label from 'components/_parts/atoms/label';
import { useFormik } from 'formik';
import { Hooks } from 'providers';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useInviteCompanyMemberMutation, useListCompanyMemberQuery } from 'components/company/hooks/useCompany';
import styled from 'styled-components';
import * as Yup from 'yup';
import './index.scss';
import LoadingCustom from 'components/layouts/loading/loading';

const LabelMod = styled(Label)`
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
max-width: 12ch;
}
`;

function Index() {
  const { t } = useTranslation();
  const inviteMemberMutation = useInviteCompanyMemberMutation();
  useListCompanyMemberQuery();
  const { setText, setModalDeleteMember, setModal } = useContext(Hooks);
  const { list, keyMemberCompany } = useSelector((state) => ({
    list: state?.company?.list,
    validationCompany: state?.auth?.company,
    keyMemberCompany: state?.loading?.listKey?.memberCompany,
  }));
  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object().shape({
      email: Yup.string()
        .email(t('general.error.valid_email'))
        .typeError('Must valid email!')
        .required(t('general.message.email_required')),
    }),
    onSubmit: async (values) => {
      await inviteMemberMutation.mutateAsync({
        email: values.email,
      });
    },
  });

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' || e.which === 13) {
      e.preventDefault();
      formik.handleSubmit();
      // call your method here
    }
  };
  const getInitial = (name) => {
    if (!name) return '';
    const wordName = name.trim().split(' ');
    const initialName = wordName.filter((v) => v.length > 0).slice(0, 2).map((w) => w[0].toUpperCase()).join('');
    return initialName;
  };
  return (
    <div className="cs_member-container">
      { keyMemberCompany ? <LoadingCustom /> : (
        <>
          <h4 className="title mb-3">{t('company.list_member')}</h4>
          <div className="cs_member-container-searchbar">
            <form onSubmit={formik.handleSubmit}>
              <Input
                type="text"
                name="email"
                isError={formik.errors.email && formik.touched.email}
                validateMessage={formik.errors.email}
                placeholder={t('company.invite_new_member')}
                onChange={formik.handleChange}
                onKeyPress={handleKeyPress}
              />
            </form>
          </div>
          <div className="cs_member-container-content scrollCustom">
            {list?.map((v) => (
              <div key={v.member_id} className="cs_member-container-content_item">
                <div className="cs_member-container-content_item-wrap-col-1 d-flex flex-row align-items-center">
                  <div className="cs_member-container-content_item_photo">
                    {v.member_profile !== null ? (
                      <img src={process.env.REACT_APP_CDN + v.member_profile} alt="img.jpg" className="cs_member-container-content_item_photo" />
                    ) : (
                      <div className="cs_member-container-content_item_defaultProfile">
                        {getInitial(v.name)}
                      </div>
                    )}
                  </div>
                  <div>
                    <LabelMod>{v.name || '-'}</LabelMod>
                  </div>
                </div>
                <div className="cs_member-container-content_item_email">
                  {v.email}
                </div>
                <div className="cs_member-container-content_item_actions">
                  <Button
                    style={{
                      backgroundColor: '#FE493D',
                      width: '26px',
                      height: '26px',
                    }}
                    icon="delete"
                    func={() => {
                      setModalDeleteMember(true);
                      setModal(true);
                      setText({
                        name: v.name ?? v.email,
                        id: v.member_id,
                        company_id: localStorage.getItem('company_id'),
                      });
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default Index;
